<div id="page-content" class="lancamentos-futuros col-md-10 col-md-offset-1">
  <div *ngIf="!loaded && !error" class="container-loading">
    <div class="btn btn-registrar loading"></div>
  </div>
  <div class="error" *ngIf="error">
    <span>Não foi possível carregar os dados</span>
  </div>
  <table id="master-detail-table-lancamentos-futuros" style="width: 100%"></table>
</div>
